module.exports = __webpack_public_path__ + "static/img/d346d28ea9e30580c47ff32148ffe114.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aboutUsBg.png
// module id = 0TSw
// module chunks = 1